<div class="header">
  <div class="menu-toggle" (click)="toggleSidebar()">
    <fa-icon [icon]="faBars"></fa-icon>
  </div>

  <div class="resaltar-palabra">
    {{ nombreCompleto }}
    <span *ngIf="mostrarEntorno" class="entorno-badge">{{ entorno }}</span>
  </div>

  <div class="spinner-overlay" *ngIf="loadingSrv.loading$ | async">
    <div class="spinner"></div>
  </div>

  <button class="logout-button" (click)="cerrarSesion()">
    Cerrar sesión &nbsp;
    <fa-icon [icon]="faSignOutAlt"></fa-icon>
  </button>
</div>

<div
  id="notificacionToast"
  class="toast align-items-center text-bg-success position-fixed top-0 end-0 p-3"
  style="z-index: 1056"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  <div class="d-flex">
    <div class="toast-body">
      {{ mensajeNotificacion }}
    </div>
    <button
      type="button"
      class="btn-close me-2 m-auto"
      data-bs-dismiss="toast"
      aria-label="Close"
    ></button>
  </div>
</div>
